import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    OnChanges,
} from '@angular/core';
import { SurveyResponse } from '@models/performance/survey-response.model';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService } from '@app/services';

@Component({
    selector: 'app-survey-display',
    templateUrl: './survey-display.template.html',
    styleUrls: ['./survey-display.style.scss'],
})
export class SurveyDisplayComponent implements OnInit, OnDestroy, OnChanges {
    @Input() fields: any[] = [];
    @Input() survey: any = {};
    @Input() response: SurveyResponse = new SurveyResponse();
    @Input() performanceReviewImprovements: boolean = false;
    @Output() saved: EventEmitter<SurveyResponse>;

    isActive = false;
    jsonResponse: any = {};
    autosave: Date;
    autosaveInterval: any = false;

    constructor(
        private element: ElementRef,
        private analyticService: AnalyticService
    ) {
        this.saved = new EventEmitter<any>();
    }

    ngOnInit(): void {
        this.renderElements();
    }

    ngOnDestroy(): void {
        this.autosaveClear();
    }

    isComplete(): boolean {
        if (this.performanceReviewImprovements) {
            return this.isCompleteWithOptionalValidation();
        }

        if (!this.jsonResponse) {
            return true;
        }

        const lengthCheck = Object.keys(this.jsonResponse).length >= this.fields.length;
        for (const response in this.jsonResponse) {
            if (this.jsonResponse[response] === null || this.jsonResponse[response] === '') {
                return false;
            }
        }

        return lengthCheck;
    }

    submit(): void {
        this.response.submittedAt = new Date();
        this.response.jsonData = this.jsonResponse;
        this.response.autoSaved = false;
        this.saved.emit(this.response);
        this.exit(false);

        this.analyticService.trackEvent(AnalyticEvents.SurveysCompleteSurveySubmit);
    }

    save(auto?: boolean): void {
        if (!this.jsonResponse) {
            if (!auto) {
                this.exit();
            }
            return;
        }

        if (typeof auto !== 'undefined' && auto && Object.keys(this.jsonResponse).length) {
            this.response.jsonData = this.jsonResponse;
            this.response.autoSaved = true;
            this.saved.emit(this.response);
            this.autosave = new Date();
        } else if (Object.keys(this.jsonResponse).length) {
            this.response.jsonData = this.jsonResponse;
            this.response.autoSaved = true;
            this.saved.emit(this.response);
            this.exit();
        } else {
            if (!auto) {
                this.exit();
            }
        }
    }

    launch(): void {
        this.autosaveSetup();

        const $container = $('.survey-display-container');
        $container.width($(window).width()).height($(window).height());
        $container.fadeIn(() => {
            this.isActive = true;
            this.renderElements();
        });

        $(window).resize(() => {
            $container.width($(window).width()).height($(window).height());
        });
    }

    exit(save = true): void {
        this.autosaveClear();
        save && this.save(true);
        $('.survey-display-container').fadeOut(() => {
            this.isActive = false;
            $('.ui.outlet').css({ 'overflow-y': 'scroll' });
        });
    }

    trackByFn(_index: number, item: any): any {
        return item.index;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['fields'] && changes['fields'].currentValue !== changes['fields'].previousValue) {
            this.renderElements();
        }
        if (changes['response'] && changes['response'].currentValue !== changes['response'].previousValue) {
            this.jsonResponse = this.response.jsonData || {};
        }
    }

    private renderMultiple(): void {
        setTimeout(() => {
            const _self = this;
            $(this.element.nativeElement)
                .find('.ui.radio.checkbox')
                .checkbox({
                    onChecked: function (): void {
                        const model = $(this).parent().data('model');
                        const value = $(this).parent().data('value');

                        _self['jsonResponse'][model] = value;
                        _self.updateMultiple();
                    },
                });
            _self.updateMultiple();
        });
    }

    private updateMultiple(): void {
        setTimeout(() => {
            const _self = this;
            $(this.element.nativeElement)
                .find('.ui.radio.checkbox')
                .each(function (): void {
                    const model = $(this).data('model');
                    const value = _self['jsonResponse'][model];

                    if (value === $(this).data('value')) {
                        $(this).checkbox('set checked');
                    }
                });
        });
    }

    private isCompleteWithOptionalValidation(): boolean {
        for (const field in this.fields) {
            if (this.fields[field].isOptional === undefined || this.fields[field].isOptional === false) {
                const answerKey = 'question' + field;
                if (
                    this.jsonResponse[answerKey] === undefined ||
                    this.jsonResponse[answerKey] === null ||
                    this.jsonResponse[answerKey] === ''
                ) {
                    return false;
                }
            }
        }

        return true;
    }

    private renderRating(): void {
        setTimeout(() => {
            const _self = this;
            $(this.element.nativeElement)
                .find('.ui.rating')
                .rating({
                    onRate: function (value: any): any {
                        const model = $(this).data('model');
                        _self['jsonResponse'][model] = value;
                    },
                });
        });
    }

    private renderScale(): void {
        setTimeout(() => {
            const _self = this;
            $('.agree-disagree-scale span').each(function (_index: number, object: any): void {
                $(object).off('click');
                $(object).on('click', function (): void {
                    const value = $(this).data('value');
                    const model = $(this).parent('.agree-disagree-scale').data('model');
                    _self['jsonResponse'][model] = value;
                    _self.updateScale();
                });
            });
            _self.updateScale();
        });
    }

    private updateScale(): void {
        setTimeout(() => {
            const _self = this;
            $('.agree-disagree-scale').each(function (): void {
                const model = $(this).data('model');
                const value = _self['jsonResponse'][model];
                const activeElement = $(this).find('[data-value="' + value + '"]');

                if (activeElement.length) {
                    $($(activeElement).parent('.agree-disagree-scale').find('span')).removeClass('active');

                    $(activeElement).addClass('active');
                }
            });
        });
    }

    private updateBoolean(): void {
        setTimeout(() => {
            const _self = this;
            $('.true-false-scale').each(function (): void {
                const model = $(this).data('model');
                const value = _self['jsonResponse'][model];
                const activeElement = $(this).find('[data-value="' + value + '"]');

                if (activeElement.length) {
                    $($(activeElement).parent('.true-false-scale').find('span')).removeClass('active');
                    $(activeElement).addClass('active');
                }
            });
        });
    }
    private renderBoolean(): void {
        setTimeout(() => {
            const _self = this;
            $('.true-false-scale span').each(function (_index: number, object: any): void {
                $(object).off('click');
                $(object).on('click', function (): void {
                    const value = $(this).data('value');
                    const model = $(this).parent('.true-false-scale').data('model');
                    _self['jsonResponse'][model] = value;
                    _self.updateBoolean();
                });
            });
            _self.updateBoolean();
        });
    }

    private renderElements(): void {
        this.renderRating();
        this.renderScale();
        this.renderBoolean();
        this.renderMultiple();
    }

    private autosaveSetup(): void {
        this.autosaveInterval = setInterval(() => {
            this.save(true);
        }, 10000);
    }

    private autosaveClear(): void {
        if (this.autosaveInterval) {
            clearInterval(this.autosaveInterval);
        }
    }
}
